import React from "react";

export function ChartCard({ title, subtitle, action, children, span = "" }) {
  return (
    <div className={`command-card p-4 lg:p-5 ${span}`}>
      <div className="flex items-start justify-between mb-3 gap-2">
        <div>
          <h3 className="font-heading font-bold text-[14px] tracking-tight text-[#0E2336]">{title}</h3>
          {subtitle && <div className="text-[11px] text-slate-500 mt-0.5">{subtitle}</div>}
        </div>
        {action}
      </div>
      <div className="w-full">{children}</div>
    </div>
  );
}

export function ChartTooltip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-md shadow-lg px-3 py-2 text-[11px]">
      <div className="font-semibold text-[#0E2336] mb-1">{label}</div>
      {payload.map((p, i) => (
        <div key={i} className="flex items-center gap-2 tabular">
          <span className="w-2 h-2 rounded-sm" style={{ background: p.color }} />
          <span className="text-slate-500">{p.name}:</span>
          <span className="font-semibold text-[#0E2336]">{Number(p.value).toLocaleString()}</span>
        </div>
      ))}
    </div>
  );
}
